import { Accessibility, Co2, SpaOutlined } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';

import { Fonts } from '@/ui/theme/fonts';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

type props = {
  type: 'co2' | 'env' | 'ess';
  scoreLetter: string;
};

export function MainScorePill({ scoreLetter, type }: props) {
  const scoreTextColor = getColorForScore(scoreLetter).text;
  const scoreBackgroundColor = getColorForScore(scoreLetter).main;

  const scoreIcon: React.ReactNode = {
    co2: (
      <div>
        <Co2 />
      </div>
    ),
    env: (
      <div>
        <SpaOutlined />
      </div>
    ),
    ess: (
      <div>
        <Accessibility />
      </div>
    ),
  }[type];

  return (
    <div>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'start'}
      >
        <Box
          sx={{
            color: scoreTextColor,
            backgroundColor: scoreBackgroundColor,
            mt: 0.5,
            mr: 1,
            px: 1.6,
            paddingTop: 0.6,
            paddingLeft: 3.5,
            paddingRight: 3.5,
            paddingBottom: 1,
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '20px',
            fontWeight: '900',
            fontFamily: Fonts.DarkerGrotesque,
            '& svg': {
              mr: 1,
              mt: 0.5,
            },
          }}
        >
          {scoreLetter || scoreIcon}
        </Box>
      </Stack>
    </div>
  );
}
